import { ROLE_HOME_ROUTES } from '@shared/auth/roleGuard'
import { ROLES, type UserRole } from '@shared/config/constants'
import { ROUTES } from '@shared/config/routes'
import { readProctorReturn } from './proctorReturn'

interface Input {
  isAuthenticated: boolean
  role: UserRole | null
  /** Свой profile id — по нему проверяется владелец контекста возврата. */
  userId: number | null
}

/**
 * Куда вести с корня сайта — и куда вести сразу после входа.
 *
 * Корень перестал быть безусловным «на логин» из-за прокторинга: PROCTOR
 * возвращает участника на адрес из своей настройки, а настроен он на корень
 * (`PROCTOR_RETURN_URL = https://test.femo.kz`). Прежний редирект показывал
 * форму входа человеку, который уже вошёл, — и его олимпиада оставалась
 * где-то позади.
 *
 * Контекст возврата читается только для участника и только своего: чужая
 * запись в этой же вкладке игнорируется (см. `readProctorReturn`).
 *
 * Возврат без контекста — не ошибка: вкладка могла быть новой, хранилище
 * недоступным. Тогда ведём на домашний экран роли, откуда олимпиады доступны
 * из бокового меню.
 */
export function resolveRootTarget({ isAuthenticated, role, userId }: Input): string {
  if (!isAuthenticated || !role) return ROUTES.LOGIN

  if (role === ROLES.PARTICIPANT) {
    const context = readProctorReturn(userId)
    // Путь собирается из шаблона роута, а не склейкой со списком: то, что
    // один адрес сейчас является префиксом другого, — совпадение, которое
    // тайпчекер не стережёт.
    if (context) {
      return ROUTES.PARTICIPANT_OLYMPIAD_DETAIL.replace(':id', String(context.olympiadId))
    }
  }

  return ROLE_HOME_ROUTES[role] ?? ROUTES.LOGIN
}
